import {createRouter, createWebHistory} from 'vue-router'
import routes from './routers.js'

const router = createRouter({
	history: createWebHistory(),
	routes: routes,
})

router.beforeEach((to, from, next) => {
	// 在这里可以进行一些路由变化的操作
	if(to && to.path)
	{
		const tolow = to.path.toLowerCase();
		if(!tolow.includes('login')) {
			sessionStorage.setItem("last-path-to", JSON.stringify({
				path: to.path,
				query: to.query,
				fullPath: to.fullPath,
				name: to.name,
			}))
		}
	}
	next();
});

export default router